import { Link } from 'react-router-dom';

import { isVideoUrl } from "../cloudinaryConfig";

export default function ProductCard({ product }) {
  const parsePrice = (v) => {
    if (!v) return 0;
    if (typeof v === 'number') return v;
    return Number(String(v).replace(/,/g, '')) || 0;
  };
  const price = parsePrice(product?.price);
  const offerPercent = Number(product?.offer) || 0;

  const hasDiscount = offerPercent > 0;
  const finalPrice = hasDiscount ? Math.round(price * (1 - offerPercent / 100)) : price;
  const discountPercent = offerPercent;
  const imagesRaw = product?.images ?? product?.image ?? null;
  const images = Array.isArray(imagesRaw)
    ? imagesRaw
    : imagesRaw
      ? [imagesRaw]
      : [];

  const mainImg = images.find(img => !isVideoUrl(img)) || (images.length > 0 ? images[0] : "");
  const isVideo = isVideoUrl(mainImg);

  return (
    <Link
      to={`/product/${product?.id}`}
      className="product-card-link link-clean"
    >
      <div className="product-card white-card rounded-4 border-0">
        <div className="product-media">
          {hasDiscount && (
            <div className="discount-badge">{discountPercent}% off</div>
          )}
          {mainImg ? (
            isVideo ? (
              <video
                src={mainImg}
                alt={product?.name}
                muted
                loop
                autoPlay
                playsInline
                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
              />
            ) : (
              <img src={mainImg} alt={product?.name} />
            )
          ) : (
            <div className="product-card-placeholder" />
          )}
        </div>
        <div className="product-body">
          <div className="product-title text-dark">{product?.name || "Product"}</div>

          <div className="product-price">
            <div className="price-current text-primary fw-bold">₹{finalPrice.toLocaleString()}</div>
            {hasDiscount && <div className="price-old text-muted-dark opacity-75">₹{price.toLocaleString()}</div>}
          </div>
        </div>
      </div>
    </Link>
  );
}

